var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5 text-center"},[_vm._v(" "+_vm._s(_vm.$t("ui-error.soon"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }